import script from "./MallPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__